@if (spec) {
    <div class="field">
        <label soho-label class="lm-builder-orientation-label">{{ 'PDFOrientation' | translate }}</label>
        <input
            type="radio"
            class="radio"
            value="landscape"
            soho-trackdirty
            id="lm-builder-pdf-orientation-landscape"
            data-automation-id="lm-builder-pdf-orientation-landscape"
            [(ngModel)]="pdfOrientation"
            (ngModelChange)="updatePdfOrientation()"/>
        <label soho-label [forRadioButton]= true for="lm-builder-pdf-orientation-landscape">{{'PDFOrientationLandscape' | translate}}</label>
        <input
            type="radio"
            class="radio"
            value="portrait"
            soho-trackdirty
            id="lm-builder-pdf-orientation-portrait"
            data-automation-id="lm-builder-pdf-orientation-portrait"
            [(ngModel)]="pdfOrientation"
            (ngModelChange)="updatePdfOrientation()"/>
        <label soho-label [forRadioButton]= true for="lm-builder-pdf-orientation-portrait">{{'PDFOrientationPortrait' | translate}}</label>
    </div>
    <div class="lm-builder-flex-column">
        <div class="field">
            <label soho-label for="lm-builder-pdf-font-offset-option">{{ 'PDFOffset' | translate }}</label>
            <select class="dropdown-sm"
                soho-dropdown
                id="lm-builder-pdf-font-offset-option"
                data-automation-id="lm-builder-pdf-font-offset-option-dropdown"
                [attributes]="pdfFontOffsetOptionIDSAttributes"
                soho-trackdirty
                [(ngModel)]="pdfOffsetOption"
                (ngModelChange)="updatePdfOffsetOption()">
                <option [value]="'default'">{{'PDFFontSizeOffsetDefault' | translate}}</option>
                <option [value]="'small'">{{'PDFFontSizeOffsetSmall' | translate}}</option>
                <option [value]="'smaller'">{{'PDFFontSizeOffsetSmaller' | translate}}</option>
                <option [value]="'smallest'">{{'PDFFontSizeOffsetSmallest' | translate}}</option>
                <option [value]="'custom'">{{'PDFFontSizeOffsetCustom' | translate}}</option>
            </select>
        </div>
        @if (pdfOffsetOption === 'custom') {
            <div class="field">
                <label soho-label for="lm-builder-custom-pdf-font-offset"></label>
                 <input
                   soho-spinbox
                   id="lm-builder-custom-pdf-font-offset"
                   data-automation-id="lm-builder-custom-pdf-font-offset"
                   class="input-xs"
                   attr.data-options="{{customPdfFontOffsetSpinBoxAttributes}}"
                   [(ngModel)]="pdfOffset"
                   (ngModelChange)="updateCustomPdfOffset()"/>
            </div>
        }
        </div>
    @if (spec.userFolder){
        <div class="field">
            <label soho-label for="lm-builder-pdf-paper-size">{{ 'PDFPaperSize' | translate }}</label>
            <select
                class="dropdown-md"
                soho-dropdown
                soho-trackdirty
                id="lm-builder-pdf-paper-size"
                name="lm-builder-pdf-paper-size"
                data-automation-id="lm-builder-pdf-paper-size-dropdown"
                data-validate="validatePDFCustomPaperSize"
                [attributes]="pdfPaperSizeIDSAttributes"
                [(ngModel)]="spec.userFolder.exportOverride.pdfPaperSize.paperSize"
                (ngModelChange)="updatePdPaperSize()">
            @for (paperSize of spec.metaDataOptions.pdfPaperSizes; track paperSize.value) {
                <option [value]="paperSize.value">{{paperSize.label}}</option>
            }
            </select>
        </div>
        @if (spec.userFolder.exportOverride.pdfPaperSize.paperSize === 'Custom') {
            <div class="lm-builder-flex-column">
                <div class="field">
                    <label soho-label [required]="spec.userFolder.exportOverride.pdfPaperSize.paperSize === 'Custom'" for="lm-builder-pdf-paper-width">{{ 'PageWidth' | translate }}</label>
                    <input
                        id="lm-builder-pdf-paper-width"
                        data-automation-id="lm-builder-pdf-paper-width-input"
                        soho-input
                        soho-mask [options]="{ process: 'number', patternOptions: { allowDecimal: true, allowNegative: false, allowLeadingZeros: false, allowThousandsSeparator: false }}"
                        soho-trackdirty
                        data-validate="validatePDFCustomPaperSize"
                        class="input-xs"
                        [maxlength]="7"
                        [(ngModel)]="spec.userFolder.exportOverride.pdfPaperSize.customDimension.width">
                </div>
                <div class="field">
                    <label soho-label [required]="spec.userFolder.exportOverride.pdfPaperSize.paperSize === 'Custom'"  for="lm-builder-pdf-paper-height">{{ 'PageHeight' | translate }}</label>
                    <input
                        id="lm-builder-pdf-paper-height"
                        data-automation-id="lm-builder-pdf-paper-height-input"
                        soho-input
                        soho-mask [options]="{ process: 'number', patternOptions: { allowDecimal: true, allowNegative: false, allowLeadingZeros: false, allowThousandsSeparator: false }}"
                        soho-trackdirty
                        data-validate="validatePDFCustomPaperSize"
                        class="input-xs"
                        [maxlength]="7"
                        [(ngModel)]="spec.userFolder.exportOverride.pdfPaperSize.customDimension.height">
                </div>
                <div class="field">
                    <label soho-label [required]="spec.userFolder.exportOverride.pdfPaperSize.paperSize === 'Custom'" for="lm-builder-pdf-paper-uom">{{'UnitOfMeasure' | translate}}</label>
                    <select
                        soho-dropdown
                        soho-trackdirty
                        id="lm-builder-pdf-paper-uom"
                        name="lm-builder-pdf-paper-uom"
                        data-automation-id="lm-builder-pdf-paper-uom-dropdown"
                        data-validate="validatePDFCustomPaperSize"
                        class="input-sm"
                        [attributes]="pdfPaperSizeUomIDSAttributes"
                        [(ngModel)]="spec.userFolder.exportOverride.pdfPaperSize.customDimension.unitOfMeasure">
                    @for (uom of spec.metaDataOptions.pdfPaperSizeUOMs; track spec) {
                        <option [value]="uom.value">{{uom.label}}</option>
                    }
                    </select>
                </div>
            </div>
        }
    }
    <label soho-label >{{ 'PDFFormatting' | translate }}</label>
    <div class="field">
<!--        <label soho-label aria-hidden></label>-->
            <input
                id="lm-builder-show-grid-lines"
                name="lm-builder-show-grid-lines"
                data-automation-id="lm-builder-show-grid-lines-input"
                soho-checkbox
                type="checkbox"
                soho-trackdirty
                [(ngModel)]="spec.showGridLines">
            <label [forCheckBox]="true" soho-label for="lm-builder-show-grid-lines">{{'Show_Grid_Lines' | translate}}</label>
    </div>
    <div class="field">
<!--        <label soho-label aria-hidden></label>-->
        <input
            id="lm-builder-suppress-headers"
            name="lm-builder-suppress-headers"
            data-automation-id="lm-builder-suppress-headers-input"
            soho-checkbox
            type="checkbox"
            soho-trackdirty
            [(ngModel)]="spec.suppressHeader">
        <label [forCheckBox]="true" soho-label for="lm-builder-suppress-headers">{{'Suppress_Headers' | translate}}</label>
    </div>
    <div class="field">
<!--        <label soho-label aria-hidden></label>-->
        <input
            id="lm-builder-suppress-footers"
            name="lm-builder-suppress-footers"
            data-automation-id="lm-builder-suppress-footers-input"
            soho-checkbox
            type="checkbox"
            soho-trackdirty
            [(ngModel)]="spec.suppressFooter">
        <label [forCheckBox]="true" soho-label for="lm-builder-suppress-footers">{{'Suppress_Footer' | translate}}</label>
    </div>
    @if(spec.userFolder) {
        <div class="lm-builder-flex-column">
            <div class="field">
                <label soho-label for="lm-builder-export-retention-duration">{{ 'RetentionDuration' | translate }}</label>
                <select
                        class="input-sm"
                        soho-dropdown
                        soho-trackdirty
                        id="lm-builder-export-retention-duration"
                        name="lm-builder-export-retention-duration"
                        data-automation-id="lm-builder-export-retention-duration-dropdown"
                        [attributes]="exportRetentionDurationIDSAttributes"
                        [(ngModel)]="exportRetentionDuration"
                        (ngModelChange)="updateExportRetentionDuration()">
                    <option [value]="'default'">{{'RetentionDurationOptionDefault' | translate}}</option>
                    <option [value]="'one-week'">{{'RetentionDurationOptionWeek' | translate}}</option>
                    <option [value]="'one-month'">{{'RetentionDurationOptionMonth' | translate}}</option>
                    <option [value]="'one-year'">{{'RetentionDurationOptionYear' | translate}}</option>
                    <option [value]="'five-years'">{{'RetentionDurationOptionFiveYear' | translate}}</option>
                    <option [value]="'custom'">{{ 'SpecifyRetention' | translate }}</option>
                </select>
            </div>
            @if (exportRetentionDuration === 'custom') {
                <div class="field" >
                    <label soho-label for="lm-builder-export-retention-duration-custom"></label>
                    <input data-automation-id="lm-builder-export-retention-duration-custom"
                           class="input-sm"
                           soho-spinbox
                           id="lm-builder-export-retention-duration-custom"
                           attr.data-options="{{exportRetentionDurationCustomSpinBoxDataOptions}}"
                           [(ngModel)]="spec.userFolder.exportOverride.retentionDuration"/>
                </div>
            }
        </div>
    }
}
